import _ from 'lodash';
import sportDisplayName from '../config/sportDisplayName';

export function formatHeadingText(country, text) {
  const displayName = _.get(sportDisplayName, `${country}.${text}`);
  if (displayName) return displayName;

  return _.chain(text)
    .capitalize()
    .replace('-', ' ')
    .value();
}



// WEBPACK FOOTER //
// ./src/util/formatSportHeadingText.js